import { useSelector } from 'react-redux';

const useIsLoggedIn = () => {
  const client = useSelector((state) => state.user || {});

  const { client_id: clientId } = client;
  const isLoggedIn = clientId !== undefined;
  return isLoggedIn;
};

export default useIsLoggedIn;
